<div *ngIf="evidence.evidenceType !== 'Credential'">
  <div class="bold">{{ evidence.evidenceDescription }}</div>
  <div *ngIf="!evidence.evidenceValue.length">(empty)</div>
</div>

<div
  fxLayout="column"
  [fxLayoutGap]="
    evidence.attributeUiType === 'Complex' || evidence.evidenceType === 'ActiveCertification' ? '20px' : ''
  "
>
  <display-data
    *ngFor="let evidenceValue of getEvidenceValues()"
    [value]="evidenceValue"
    [showAllFields]="showAllFields"
    [evidence]="evidence"
  >
    <button
      *ngIf="evidence.attributeUiType === 'Document'"
      mat-icon-button
      aria-label="Download button"
      (click)="openEvidenceImageInS3(evidenceValue, evidence)"
    >
      <mat-icon>download</mat-icon>
    </button>
  </display-data>
</div>
